import {
  PartTypeAccessory,
  PartTypePackage,
  PartTypeTire,
  PartTypeWheel,
  partTypeTire,
} from "../../constants/partTypes";
import { Language } from "../../i18n/useLanguage";
import { TirePartSummary } from "../../queries/useSearchTiresByVehicle";
import { AnyPartItem } from "../../stores/slices/cartSlice";
import { PricingOption, getFlatPricingOptions } from "./getFlatPricingOptions";

export type CombinedPart = {
  itemId: string;
  itemType: PartTypeAccessory | PartTypePackage | PartTypeTire | PartTypeWheel;
  partNumber: null | string;
  pricingOptions: PricingOption[];
};

interface CombineParts {
  (
    part: AnyPartItem | null,
    isStaggered: boolean,
    language: Language
  ): CombinedPart[];
}

export const combinePartsForPricing: CombineParts = (
  part,
  isStaggered,
  language
) => {
  if (!part) {
    return [];
  }
  const primaryPart = {
    itemId: part.partSummary.primaryPart.itemId,
    itemType: part.partSummary.primaryPart.itemType,
    partNumber:
      part.partSummary.primaryPart.itemType === partTypeTire
        ? part.partSummary.primaryPart.itemNationalPartNumber ||
          part.partSummary.primaryPart.itemPartNumber
        : null,
    pricingOptions: getFlatPricingOptions(
      part.partPricing.primaryPart,
      language
    ),
  };
  const secondaryParts = isStaggered
    ? part.partSummary.secondaryParts
        .map((p, key) => ({
          itemId: p.itemId,
          itemType: p.itemType,
          partNumber:
            part.partSummary.primaryPart.itemType === partTypeTire
              ? (p as TirePartSummary).itemNationalPartNumber ||
                p.itemPartNumber
              : null,
          pricingOptions: getFlatPricingOptions(
            part.partPricing.secondaryParts[key],
            language
          ),
        }))
        .slice(0, 1)
    : [];
  const combinedParts = [primaryPart, ...secondaryParts];
  return combinedParts;
};
